function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import * as React from "react";
import { useQuery } from "@tanstack/react-query";
import { fetchPolizaRenewalVersions, getVersionsQueryKey } from "./actions/PolizaRenewalActions";
import PolizaRenewalVersionListItem from "./components/PolizaRenewalVersionListItem";

var IndexPolizaRenewalVersions = function IndexPolizaRenewalVersions(props) {
  var poliza_renewal_id = props.poliza_renewal_id,
      admin = props.admin;

  var _React$useReducer = React.useReducer(function (x) {
    return x + 1;
  }, 0),
      _React$useReducer2 = _slicedToArray(_React$useReducer, 2),
      ignored = _React$useReducer2[0],
      forceUpdate = _React$useReducer2[1];

  var _useQuery = useQuery({
    queryKey: getVersionsQueryKey(poliza_renewal_id),
    queryFn: function queryFn() {
      return fetchPolizaRenewalVersions(poliza_renewal_id);
    }
  }),
      data = _useQuery.data,
      error = _useQuery.error,
      isLoading = _useQuery.isLoading;

  var polizaRenewalVersions = data === null || data === void 0 ? void 0 : data.versions;

  var renderPolizaRenewalVersions = function renderPolizaRenewalVersions() {
    if (isLoading) {
      return /*#__PURE__*/React.createElement("p", null, "Cargando historial de cambios...");
    }

    if (error) {
      return /*#__PURE__*/React.createElement("p", null, "Error al cargar el historial de cambios.");
    }

    if (polizaRenewalVersions && polizaRenewalVersions.length > 0) {
      return polizaRenewalVersions.map(function (polizaRenewalVersion) {
        return /*#__PURE__*/React.createElement(PolizaRenewalVersionListItem, {
          key: polizaRenewalVersion.id,
          polizaRenewalVersion: polizaRenewalVersion,
          onUpdate: forceUpdate,
          admin: admin
        });
      });
    }

    return /*#__PURE__*/React.createElement("p", null, "No hay historial de cambios en la renovaci\xF3n.");
  };

  return /*#__PURE__*/React.createElement("div", {
    className: "card renewalHistoryCard w-100"
  }, /*#__PURE__*/React.createElement("div", {
    className: "card-body renewalHistoryBody"
  }, renderPolizaRenewalVersions()));
};

export default IndexPolizaRenewalVersions;